import {FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_REQUEST,FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_SUCCEDDED, FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_FAILED,UPDATING_WOPI_INTEGRATION_ASSET_SUCCEDDED,UPDATING_WOPI_INTEGRATION_ASSET_REQUEST,WS_ASSET_PROCESSED,UPDATING_WOPI_INTEGRATION_ASSET_FAILED,INVALIDATE_WOPI_INTEGRATION} from "../actions/actionTypes";
import {
  FetchWopiAssetDetailsRequest,
  FetchWopiAssetDetailsResponse,
  FetchWopiAssetDetailsErrorResponse
} from "../../types/microsoftWopiIntegration";
import { UnknownAction } from "redux-saga";

import _ from "lodash";


interface WopiIntegrationState {
  loading: boolean,
  item: FetchWopiAssetDetailsResponse | null,
  error: {
    code: number | null,
  },
  asset: {
    updating: boolean,
    processed: boolean,
    item: any | null,
    error: any | null
  },
};

const initialState: WopiIntegrationState = {
  loading: false,
  item: null,
  error: {
    code: null,
  },
  asset: {
    updating: false,
    processed: false,
    item: null,
    error: null
  },
};  

type Action = UnknownAction;

export function microsoftWopiIntegrationReducer(
  state: WopiIntegrationState  = initialState,
  action: Action,
): WopiIntegrationState {
  switch (action.type) {
    case FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_SUCCEDDED:
      const response = action.payload as FetchWopiAssetDetailsResponse;
      return {
        ...state,
        loading: false,
        item: response
      };

    case FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_FAILED:
      const {error} = action.payload as FetchWopiAssetDetailsErrorResponse;
      return {
        ...state,
        loading: false,
        item: null,
        error: error
      };  
      case UPDATING_WOPI_INTEGRATION_ASSET_REQUEST:
      return {
        ...state,
        asset: {
          ...state.asset,
          updating: true
        }
      };

    case UPDATING_WOPI_INTEGRATION_ASSET_SUCCEDDED:
      return {
        ...state,
        asset: {
          ...state.asset,
          updating: false,
          item: action.payload
        }
      };

    case UPDATING_WOPI_INTEGRATION_ASSET_FAILED:
      return {
        ...state,
        asset: {
          ...state.asset,
          updating: false,
          item: null,
          error: action.payload
        }
      };


    case INVALIDATE_WOPI_INTEGRATION:
      return {
        ...state,
        loading: false,
        item: null,
        error: { code: null },
        asset: {
          updating: false,
          processed: false,
          item: null,
          error: null
        },
      };


    case WS_ASSET_PROCESSED:
      if (!state.asset.item) {
        return state;
      }
      const assetId = (action.payload as any)?.id;
      const processed = state.asset.item.id == assetId;
      
      return {
        ...state,
        asset: {
          ...state.asset,
          processed: processed
        },
      };


    default:
      return state;
  } 
}